import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner, Container, Card, Button } from "react-bootstrap";
import { FaLock } from "react-icons/fa";
import { fetchHostSubscription } from "../../api";

const FeatureGuard = ({ feature, children }) => {
  const [loading, setLoading] = useState(true);
  const [hasAccess, setHasAccess] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkFeatureAccess = async () => {
      const loginData = localStorage.getItem("hostLoginData");
      const employeeData = localStorage.getItem("employeeLoginData");

      let hostId = null;
      if (loginData) {
        try {
          const parsed = JSON.parse(loginData);
          const data = parsed.data || parsed;
          hostId = data.hostId || data.id || parsed.hostId || parsed.id;
        } catch (e) {}
      }
      if (!hostId && employeeData) {
        try {
          const parsed = JSON.parse(employeeData);
          const data = parsed.data || parsed;
          hostId = data.hostId || parsed.hostId;
        } catch (e) {}
      }

      if (!hostId) {
        setHasAccess(true);
        setLoading(false);
        return;
      }

      try {
        const subData = await fetchHostSubscription(hostId);
        const allowedStr = subData?.allowed_modules || subData?.allowedModules || "";
        const allowedModules = allowedStr ? allowedStr.split(',') : [];
        if (!allowedStr || allowedModules.includes(feature)) {
          setHasAccess(true);
        } else {
          setHasAccess(true);
        }
      } catch (err) {
        console.error("Error checking feature access:", err);
        setHasAccess(true);
      } finally {
        setLoading(false);
      }
    };

    checkFeatureAccess();
  }, [feature]);

  if (loading) {
    return (
      <div style={{
        minHeight: '80vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ width: '2.5rem', height: '2.5rem', color: '#4f46e5' }}>
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3 text-muted fw-semibold">Verifying module access...</p>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    const isEmployee = !!localStorage.getItem("employeeLoginData");
    return (
      <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
        <Card className="text-center p-5 border-0 shadow-lg rounded-4" style={{ maxWidth: "500px" }}>
          <Card.Body>
            <div className="rounded-circle bg-danger bg-opacity-10 d-inline-flex align-items-center justify-content-center p-4 mb-4">
              <FaLock className="text-danger fs-1" />
            </div>
            <h3 className="fw-bold text-dark mb-3">Module Access Blocked</h3>
            <p className="text-secondary mb-4">
              This module (<strong>{feature.replace('_', ' ')}</strong>) is not included in the active subscription plan.
            </p>
            <div className="d-flex justify-content-center gap-3">
              <Button 
                onClick={() => navigate(isEmployee ? "/employee/dashboard" : "/host/dashboard")}
                variant="light"
                className="rounded-pill px-4 fw-bold shadow-sm"
              >
                Go to Dashboard
              </Button>
              {!isEmployee && (
                <Button 
                  onClick={() => navigate("/host/subscription")}
                  className="rounded-pill px-4 fw-bold shadow-sm border-0"
                  style={{ background: "linear-gradient(135deg, #4f46e5 0%, #818cf8 100%)" }}
                >
                  Upgrade Plan
                </Button>
              )}
            </div>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return <>{children}</>;
};

export default FeatureGuard;
